export default "__VITE_ASSET__DQnI_pBg__"